/* eslint-disable no-console */
/* eslint-disable no-alert */
import { motion } from 'framer-motion';
import React, { useEffect, useState } from "react";
import {
    FaFacebook, FaTwitter, FaLinkedin, FaInstagram,
    FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock,
    FaChevronUp
} from 'react-icons/fa';
import { FiMail, FiPhone, FiSend, FiWhatsApp, FiCheck } from 'react-icons/fi';
import { SiUpwork } from "react-icons/si";
import LocationFooter from './LocationFooter';
import NewsletterForm from './NewsletterForm';


// import { SiUpwork, SiFiverr } from 'react-icons/si';

const Footer = () => {
    const [newsletterData, setNewsletterData] = useState({
        email: '',
        phone: ''
    });
    // Replace with your actual WhatsApp number (include country code without + or spaces)
    const ADMIN_WHATSAPP_NUMBER = process.env.REACT_APP_ADMIN_WHATSAPP || '61450290914'; // Example: '911234567890'
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);

    //     const dataForm = new FormData(e.target);
    //     const data = Object.fromEntries(dataForm);

    //     const contactPayload = {
    //         email: data.email,
    //     };

    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_API_URL}/api/uni/subscribe`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(contactPayload),
    //         });

    //         if (!response.ok) {
    //             throw new Error("Failed to submit contact form");
    //         }

    //         setIsSubmitted(true);
    //     } catch (err) {
    //         console.error("Submission error:", err);
    //         alert("Failed to submit form. Please try again.");
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const handleWhatsAppSend = () => {
        // Validate both fields are filled
        if (!newsletterData.email || !newsletterData.phone) {
            alert('Please fill in both email and phone number before sending via WhatsApp.');
            return;
        }

        const message = `
*New Newsletter Subscription*
*Email:* ${newsletterData.email}
*Phone:* ${newsletterData.phone}
        `.trim();

        const encodedMessage = encodeURIComponent(message);
        const whatsappLink = `https://wa.me/${ADMIN_WHATSAPP_NUMBER}?text=${encodedMessage}`;
        window.open(whatsappLink, '_blank');
        setIsSubmitted(true);
    };
    const handleNewsletterChange = (e) => {
        const { name, value } = e.target;
        setNewsletterData(prev => ({ ...prev, [name]: value }));
    };

    const footerLinks = [
        {
            title: "Services",
            links: [
                 { name: "UniProID", url: "/unipro" },
                { name: "Web Development", url: "/webdev" },
                { name: "Mobile Apps", url: "/mobileapp" },
                { name: "Shopify Webdevelopment", url: "/shopdev" },
                { name: "Game Development", url: "/gamedev" },
                { name: "UI/UX Design", url: "/uiux" },

            ]
        },
        {
            title: "Company",
            links: [
                { name: "About Us", url: "/about" },
                { name: "Careers", url: "/carrer" },
                { name: "Contact", url: "/quickenquiry" },
                { name: "Faqs", url: "/faqspage" }
            ]
        },
        {
            title: "Resources",
            links: [
                { name: "Blog", url: "/blogs" },
                // { name: "Case Studies", url: "/casestudy" },
                // { name: "Work", url: "/portfolio" },
                { name: "Testimonials", url: "/testimonials" }

            ]
        }
    ];



    const socialLinks = [
        // { icon: <FaFacebook />, url: "#", name: "Facebook" },
        { icon: <FaTwitter />, url: "#", name: "Twitter" },
        { icon: <FaLinkedin />, url: "#", name: "LinkedIn" },
        // { icon: <FaInstagram />, url: "#", name: "Instagram" },
        { icon: <SiUpwork />, url: "#", name: "Upwork" },
        // { icon: <SiFiverr />, url: "#", name: "Fiverr" }
    ];

    return (
        <footer className="bg-gradient-to-b from-gray-900 to-gray-800 text-white pt-16 pb-8 px-4 sm:px-6 lg:px-8 relative overflow-hidden ">
            {/* Animated background elements */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10">
                <div className="absolute -top-20 -left-20 w-64 h-64 bg-blue-500 rounded-full filter blur-3xl" />
                <div className="absolute bottom-10 right-10 w-80 h-80 bg-purple-600 rounded-full filter blur-3xl" />
            </div>

            <div className="max-w-7xl mx-auto relative z-10">
                {/* Main footer content */}
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-10 mb-12">
                    {/* Company info */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="space-y-4"
                    >
                        <h3 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
                            <img src="/unitechlogo2.webp" alt="UniTechnoStack" />
                        </h3>
                        <p className="text-gray-300">
                            Transforming ideas into digital reality through innovative technology solutions and creative design.
                        </p>
                        {/* <div className="flex space-x-4">
                            {socialLinks.slice(0, 4).map((social, index) => (
                                <motion.a
                                    key={index}
                                    href={social.url}
                                    aria-label={social.name}
                                    whileHover={{ y: -3, scale: 1.1 }}
                                    className="text-gray-300 hover:text-white transition-colors text-xl"
                                >
                                    {social.icon}
                                </motion.a>
                            ))}
                        </div> */}

                    </motion.div>

                    {/* Footer links */}
                    {footerLinks.map((section, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            className="space-y-4"
                        >
                            <h4 className="text-lg font-semibold text-white">{section.title}</h4>
                            <ul className="space-y-3">
                                {section.links.map((link, linkIndex) => (
                                    <li key={linkIndex}>
                                        <motion.a
                                            href={link.url}
                                            whileHover={{ x: 5 }}
                                            className="text-gray-300 hover:text-blue-400 transition-colors flex items-center"
                                        >
                                            <span className="w-1 h-1 bg-blue-400 rounded-full mr-2" />
                                            {link.name}
                                        </motion.a>
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    ))}

                    {/* Contact info */}

                </div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="w-full bg-black rounded-xl"
                >
                    {/* Header with accent bar */}
                    <div className="flex items-center mb-2 p-6">
                        <div className="h-8 w-1 bg-gradient-to-b from-blue-400 to-purple-500 rounded-full mr-3" />
                        <h4 className="text-xl font-bold text-white">Contact Information</h4>
                    </div>


                    <LocationFooter />
                </motion.div>
                {/* Newsletter */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-xl mt-10 p-6 mb-12 border border-gray-700/50"
                >

                    {isSubmitted ? (
                        <div className=" rounded-2xl  sm:p-10 text-center">
                            <motion.div
                                initial={{ scale: 0.8 }}
                                animate={{ scale: 1 }}
                                transition={{ type: "spring" }}
                                className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center mx-auto "
                            >
                                <FiCheck className="text-green-500 text-4xl" />
                            </motion.div>
                            <h2 className="text-2xl font-bold  text-white">Thank You!</h2>
                            <p className="text-white ">
                                You&apos;ve successfully subscribed to our newsletter. Stay tuned for updates and offers!.
                            </p>

                        </div>
                    ) : (
                        <div className="flex flex-col md:flex-row justify-between items-center">
                            <h3 className="text-lg font-semibold text-white mb-3">Subscribe to Our Newsletter</h3>
                            <p className="text-sm text-gray-300 mb-4">Get the latest updates on projects and offers</p>
                            <form onSubmit={handleWhatsAppSend} className="space-y-3">
                                {/* Email Field */}
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FiMail className="text-gray-400" />
                                    </div>
                                    <input
                                        type="email"
                                        name="email"
                                        value={newsletterData.email}
                                        onChange={handleNewsletterChange}
                                        required
                                        placeholder="Your email address"
                                        className="w-full pl-10 px-4 py-3 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        aria-label="Email for newsletter"
                                    />
                                </div>

                                {/* Phone Field */}
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FiPhone className="text-gray-400" />
                                    </div>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={newsletterData.phone}
                                        onChange={handleNewsletterChange}
                                        required
                                        placeholder="Your mobile number"
                                        className="w-full pl-10 px-4 py-3 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        aria-label="Phone number for newsletter"
                                    />
                                </div>

                                {/* Submit Buttons */}
                                <div className="space-y-3">
                                    {/* <motion.button
                                                  whileHover={{ scale: 1.02 }}
                                                  whileTap={{ scale: 0.98 }}
                                                  type="submit"
                                                  disabled={isSubscribing}
                                                  className="w-full bg-gradient-to-r from-blue-500 to-purple-500 px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-opacity flex items-center justify-center"
                                              >
                                                  {isSubscribing ? (
                                                      <>
                                                          <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                                          </svg>
                                                          Subscribing...
                                                      </>
                                                  ) : (
                                                      <>
                                                          <FiSend className="mr-2" />
                                                          Subscribe
                                                      </>
                                                  )}
                                              </motion.button> */}

                                    <motion.button
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        type="submit"
                                        disabled={isSubmitted}
                                        className="w-full bg-gradient-to-r from-blue-500 to-purple-500 px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-opacity flex items-center justify-center"
                                    >
                                        {isSubmitted ? (
                                            <>
                                                <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                                </svg>
                                                Subscribing...
                                            </>
                                        ) : (
                                            <>
                                                <FiSend className="mr-2" />
                                                Subscribe
                                            </>
                                        )}
                                    </motion.button>
                                </div>


                            </form>
                        </div>)}


                </motion.div>

                {/* Bottom footer */}
                <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.5 }}
                        className="text-white text-sm mb-4 md:mb-0 text-center"
                    >
                        © {new Date().getFullYear()} UniTechnoStack. All rights reserved.
                    </motion.p>


                    <div className="flex space-x-6">
                        <motion.a
                            href="/privacy"
                            whileHover={{ scale: 1.05 }}
                            className="text-white hover:text-white text-sm transition-colors"
                        >
                            Privacy Policy
                        </motion.a>
                        <motion.a
                            href="/termsconditions"
                            whileHover={{ scale: 1.05 }}
                            className="text-white hover:text-white text-sm transition-colors"
                        >
                            Terms of Service
                        </motion.a>
                        <motion.a
                            href="/cookiepolicy"
                            whileHover={{ scale: 1.05 }}
                            className="text-white hover:text-white text-sm transition-colors"
                        >
                            Cookie Policy
                        </motion.a>
                    </div>

                    <motion.button
                        onClick={scrollToTop}
                        whileHover={{ y: -3 }}
                        whileTap={{ scale: 0.95 }}
                        aria-label="Scroll to top"
                        className="mt-4 md:mt-0 flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg"
                    >
                        <FaChevronUp />
                    </motion.button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;